export default "__VITE_ASSET__4DcGYwjk__"